<template>
  <div class="flex items-center gap-3 opacity-80" :class="wrapperClass">
    <div
      class="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
      :class="[circleBgClass, circleBorderClass]"
    >
      <i v-if="iconClass" :class="[iconClass, iconColorClass]" class="block"></i>
      <slot v-else name="icon" />
    </div>
    <span :class="[textClass, textColorClass]">{{ text }}</span>
  </div>
</template>

<script setup>
defineProps({
  text: { type: String, default: '' },
  iconClass: { type: String, default: '' },
  iconColorClass: { type: String, default: 'text-[#ecd79f]' },
  textClass: { type: String, default: 'text-xs font-bold tracking-[0.2em] uppercase' },
  textColorClass: { type: String, default: 'text-inherit' },
  circleBgClass: { type: String, default: 'bg-white/10' },
  circleBorderClass: { type: String, default: 'border border-white/10' },
  wrapperClass: { type: String, default: '' }
});
</script>
